/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _9 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>9 - Композиция редюсеров</h2>
    <p className={styles.description}>
      Еще одна полезная функция Redux - возможность делать композицию редьюсеров, то есть совмещать много в один. Это
      позволяет удобно поддерживать гораздо более сложные состояния в больших приложениях. Для этого используется
      функция <code className={styles.code}>combineReducers()</code>.{' '}
    </p>
    <CopyBlock
      text={`import { combineReducers } from 'redux';
import notesReducer from './notes';
import filterReducer from './filter';

const rootReducer = combineReducers({
  notes: notesReducer,
  filter: filterReducer,
});

export default rootReducer;
`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
